<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import { useRoute } from "vue-router";
import { computed } from "vue";
import { usePatient } from "@/composables/models/patient/usePatient.ts";
import { useAbility } from "@casl/vue";
import AlignerDeliveryAddEdit from "@/components/models/patient/forms/visitInstructions/AlignerDeliveryAddEdit.vue";

definePage({
  meta: {
    title: "generic.action.addEntity",
    titleParams: { entity: "generic.entity.alignerDeliveryInstructions" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.CREATE, $permSubjects.PATIENT__ALIGNERDELIVERYINSTRUCTIONS);
    },
  },
});

const route = useRoute();
const routeParams = route.params as { id: string };
const { data: patient, isLoading: isPatientLoading } = usePatient({
  id: computed(() => routeParams.id),
});
</script>

<template>
  <v-skeleton-loader :loading="isPatientLoading">
    <aligner-delivery-add-edit
      :patient="patient"
      creating
    />
  </v-skeleton-loader>
</template>

<style scoped></style>
